import { OptInPersonalData } from 'features/free-samples/services/types';

export const initialFormData: OptInPersonalData = {
  zip_code: '',
  crm: '',
  cpf: '',
  existing_clinic_address: false,
};
